import { eventType, customFieldTypes, componentMapper, attachmentTypes, status, cookieConstant } from '@/services/constants'
import { hideMessage, emitEventToParentWindow } from '@/services/utils'
import store from '../store'
import { v4 as uuidV4 } from 'uuid'
import { getCookie } from './cookie'

export function extractCustomFields (messages, isLastBotResponse, isCallbackEventTriggered = false) {
    let result
    messages?.customFields?.forEach(field => {
        let value
        if (field.values?.length && customFieldTypeMap[field.name.toUpperCase()]) {
            value = customFieldTypeMap[field.name.toUpperCase()]({ field, messages, isLastBotResponse, isCallbackEventTriggered })

        } else if (field.values?.length && customFieldTypeMap[field.name]) {
            value = customFieldTypeMap[field.name]({ field, messages, isLastBotResponse, isCallbackEventTriggered })
        }
        if(value !== undefined) {
          result = value
        }
    })
    return result
}

const customFieldTypeMap = {
  [customFieldTypes.FORMID]: ({ messages, field, isLastBotResponse }) => {
    return showFormUsingFormId(messages, field, isLastBotResponse)
  },
  [customFieldTypes.FORM_ID]: ({ messages, field, isLastBotResponse }) => {
    return showFormUsingFormId(messages, field, isLastBotResponse)
  },
  [customFieldTypes.FORM_URL]: ({ messages, field }) => {
    return showFormUsingFormURL (messages, field)
  },
  [customFieldTypes.FORM_SCHEMA]: ({ messages, field }) => {
    return showFormUsingSchema(messages, field)
  },
  [customFieldTypes.SURVEY_SCHEMA]: ({ messages, field }) => {
    return showFormUsingSurvey(messages, field)
  },
  [customFieldTypes.PRIMARY_LANGUAGE]: ({ field }) => {
    store.dispatch('updatePrimaryLanguage', field.values[0])
  },
  [customFieldTypes.DISABLE_CHAT_INPUT_FIELD]: ({ field }) => {
    store.dispatch('updateInputFieldDisableStatus', field.values[0] === 'true')
  },
  [customFieldTypes.DISABLE_INPUT_FIELD]: ({ field }) => {
    store.dispatch('updateInputFieldTempDisableStatus', field.values[0] === 'true')
  },
  [customFieldTypes.END_CHAT_FIELD]: () => {
    store.dispatch('updateEndChatCustomFieldStatus', true)
  },
  [customFieldTypes.CALLBACK_EVENT]: ({ field, isCallbackEventTriggered }) => {
    if (!isCallbackEventTriggered) {
      emitEventToParentWindow(eventType.NETOMI_FORM_SUBMIT_EVENT, {callbackValue: field.values[0]})
    }
  },
  [customFieldTypes.ZD_CHAT_CLEAR_TAGS]: () => {
    store.dispatch('clearTags')
  },
  [customFieldTypes.NETOMI_HANDOVER_DEPARTMENT_NAME]: ({ field }) => {
    store.dispatch('updateHandoffDepartment', field.values[0])
  },
  [customFieldTypes.ZD_CHAT_VISITOR_NAME]: ({ field }) => {
    store.dispatch('updateVisitorInfo', { display_name: field.values[0]?.trim() })
  },
  [customFieldTypes.ZD_CHAT_VISITOR_EMAIL]: ({ field }) => {
    store.dispatch('updateVisitorInfo', { email: field.values[0]?.replace(/\s+/g, '') })
  },
  [customFieldTypes.ZD_CHAT_VISITOR_PHONE]: ({ field }) => {
    store.dispatch('updateVisitorInfo', { phone: field.values[0]?.trim() })
  },
  [customFieldTypes.ZD_LIVE_HANDOFF_TAGS]: ({ field }) => {
    store.dispatch('addTags', field.values)
  }
}

function showFormUsingFormId(messages, form, isLastBotResponse) {
    return (
        form && [
        {
          messageId: uuidV4(),
          requestId: messages.requestId,
          type: componentMapper[attachmentTypes.MessageInfoAttachment][0],
          hide: hideMessage(
            {
              attachment: {
                values: {
                  status: [status.PENDING]
                }
              }
            },
          componentMapper[attachmentTypes.MessageInfoAttachment][0],
          isLastBotResponse
          ),
          messageValue: {
          formId: form.values[0],
          values: {
            status: [status.PENDING]
          }
          },
          timestamp: parseInt(messages.timestamp),
          isUser: false
        }
      ]
    )
}
  
  function showFormUsingFormURL (messages, html) {
    return (
      html && [
        {
          messageId: uuidV4(),
          requestId: messages.requestId,
          type: componentMapper[attachmentTypes.MessageInfoAttachment][1],
          hide: false,
          messageValue: {
            isURL: true,
            source: html.values[0],
            status: [status.PENDING],
            iframeHeightWithOnlyQuestions: [0]
          },
          timestamp: parseInt(messages.timestamp),
          isUser: false
        }
      ]
    )
  }
  
  function showFormUsingSchema(messages, schema) {
    return (
      schema && [
        {
          messageId: uuidV4(),
          requestId: messages.requestId,
          type: componentMapper[attachmentTypes.MessageInfoAttachment][2],
          hide: false,
          messageValue: {
            schema: schema.values[0],
            status: [status.PENDING],
          },
          timestamp: parseInt(messages.timestamp),
          isUser: false
        }
      ]
    )
  }

function showFormUsingSurvey(messages, schema) {
  return (
    schema && [
      {
        messageId: uuidV4(),
        requestId: messages.requestId,
        conversationId: messages.requestPayload.conversationId || getCookie(cookieConstant.SESSION.CONVERSATION_ID),
        type: componentMapper[attachmentTypes.MessageInfoAttachment][3],
        hide: false,
        messageValue: {
          schema: schema.values[0],
          status: [status.PENDING],
        },
        timestamp: parseInt(messages.timestamp),
        isUser: false
      }
    ]
  )
}
